// Node Modules
import React from "react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import renderHTML from "react-render-html";

import Image from "components/image/image";

import DashedLineBreakHeader from "../components/dashedLineBreakHeader/dashedLineBreakHeader";

import "./orderingInfo.css";

import LineDetailColors from "./assets/line-detail-colors-compressed.jpg";
import RecotexSquare from "./assets/recotex-square.jpg";

class OrderingInfo extends React.Component {
  render() {
    return (
      <div className="content orderingInfo">
        <DashedLineBreakHeader title="Ordering" first />
        <h1>Colorways</h1>
        <p>
          Our Greige fabric is hand-painted with black and white screen printing
          ink as well as glow in the dark / UV reactive detail lines in three
          colors:
        </p>
        <Image src={LineDetailColors} />
        <p>
          Products from the hand-painted line pictured on our site are not the
          exact garments sold.
        </p>
        <p>
          The painted pattern will vary from garment to garment of the same
          style because each piece is cut from large scale fabric paintings and
          is truly one-of-a-kind.
        </p>
        <p>Our current Activewear fabric is black:</p>
        <div className="centerImage">
          <Image src={RecotexSquare} />
        </div>
        <p className="center">→ More colorways coming soon ←</p>
        <h1>Sizing Info</h1>

        <p>
          Our hand-painted line is designed to have a relaxed outerwear fit.
        </p>
        <p>
          If you prefer a closer or looser fit, please refer to the size chart
          for each garment and consider ordering a size down or a size up before
          purchasing.
        </p>

        <p>
          Our activewear line is designed to have a form-fitting athletic
          stretch fit.
        </p>
        <p>
          If you prefer a closer or looser fit, please refer to the size chart
          for each garment and consider ordering a size down or a size up before
          purchasing.
        </p>
        <h1>Production Time</h1>

        <p>
          As part of the slow fashion movement we aim to avoid the excess of
          overproduction by having our garments made based on a pre-order
          system.
        </p>
        <p>
          Our pre-order periods are two weeks long and at the end of the period
          we begin our two week production cycle, meaning we produce our orders
          every two weeks.
        </p>
        <p>
          Because HECHA / 做 is made to order in NYC, we ask that you please
          allow at least 2-4 weeks for painting and/or production before your
          item(s) ships.
        </p>
        <p>
          Free shipping code available for local NYC pickup, please{" "}
          <a
            href="mailto:hechanyc@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            email us
          </a>{" "}
          before placing your order!
        </p>
        <DashedLineBreakHeader title="Limited Lifetime Warranty" />
        <p>
          Our goal is for HECHA / 做 products to last longer than a fashion
          cycle (at the very least) and hope to encourage consumers to reduce
          waste by taking care of and repairing their clothing rather than
          disposing of it.
        </p>
        <p>
          HECHA / 做 items have a lifetime warranty: Our warranty is valid only
          when the product is purchased via hechanyc.com directly or through an
          authorized reseller. The products eligible for the lifetime warranty
          are covered to the original owner, for the lifetime of the product.
        </p>
        <p>
          If the item is defective or damaged upon receipt we will repair or
          replace the item at our discretion.
        </p>
        <p>
          Damages not covered are those resulting from abuse, accidental damage,
          normal wear and tear, and cosmetic damages that do not affect the
          functionality of the item (such as scratches, stained fabrics, or the
          natural breakdown of colors and materials over extended time and use).
        </p>
        <p>Damages covered include hardware replacement and reattachment:</p>
        <ul>
          <li>→ Replacing and/or re-attaching buttons or buckles</li>
          <li>→ Replacing elastic straps if they stretch out or deteriorate</li>
          <li>→ Re-attaching elastic straps or zippers</li>
        </ul>
        <p>
          Any damage that is not covered under our warranty can still be
          repaired for a reasonable rate upon agreement via email.
        </p>
        <p>
          The customer will be responsible for paying any repairment shipping
          costs, however local NYC drop-off and pick-up is free. For any
          warranty related requests, please{" "}
          <a
            href="mailto:hechanyc@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            email us
          </a>{" "}
          your order number and reason for repair with pictures documenting the
          issue.
        </p>

        {/* {this.props.policies.refundPolicy.body !== null && ( */}
        <div>
          <DashedLineBreakHeader title="Refund Policy" />
          {/* {this.props.policies.refundPolicy.body} */}
          {renderHTML(documentToHtmlString(this.props.content))}
        </div>
        {/* )} */}
      </div>
    );
  }
}
export default OrderingInfo;
